import { useTranslation } from 'libs/i18n'
import { Badge } from 'shared/atoms'
import type { BadgeVariant } from 'shared/atoms/Badge/Badge'
import type { CouponStatus as CouponStatusValue } from '../../types/coupons.types'

const variants: Record<CouponStatusValue, BadgeVariant> = {
	active: 'success',
	scheduled: 'primary',
	expired: 'muted',
	exhausted: 'warning',
	inactive: 'danger'
}

export const useCouponStatusLabel = () => {
	const { t } = useTranslation()
	const labels: Record<CouponStatusValue, string> = {
		active: t('Active'),
		scheduled: t('Scheduled'),
		expired: t('Expired'),
		exhausted: t('Used up'),
		inactive: t('Inactive')
	}
	return (status: CouponStatusValue) => labels[status] ?? status
}

export const CouponStatus = ({ status }: { status: CouponStatusValue }) => {
	const label = useCouponStatusLabel()

	return (
		<Badge variant={variants[status] ?? 'muted'} uppercase>
			{label(status)}
		</Badge>
	)
}
